import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineSkusRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.skus),
  findOneByProductColorId: async (productColorId: string) => {
    return offlineDatabase.skus.filter((sku) => sku.productColorId === productColorId).first();
  },
  findByProductColorId: async (productColorId: string) => {
    return offlineDatabase.skus.filter((sku) => sku.productColorId === productColorId).toArray();
  },
  findByProductColorIds: async (productColorIds: string[]) => {
    const idsSet = new Set(productColorIds);
    return offlineDatabase.skus.filter((sku) => idsSet.has(sku.productColorId)).toArray();
  },
};
